export default "__VITE_ASSET__1ipkSuqc__"